import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
  FORGET_PASSWORD_RESEND_CODE,
  FORGET_PASSWORD_RESEND_CODE_SUCCESS,
  FORGET_PASSWORD_RESEND_CODE_ERROR
} from "./actionTypes"

const initialState = {
  forgetSuccessMsg: null,
  forgetError: null,
  forgetLoader: null,
}

const forgetPassword = (state = initialState, action) => {
  switch (action.type) {
    case FORGET_PASSWORD: 
      state = {
        ...state,
        forgetSuccessMsg: null,
        forgetError: null,
        forgetLoader: true,
      }
      break
    case FORGET_PASSWORD_SUCCESS: 
      state = {
        ...state,
        forgetSuccessMsg: action.payload,
        forgetLoader: false,
      }
      break
    case FORGET_PASSWORD_ERROR: 
      state = { ...state, forgetError: action.payload, forgetLoader: null, }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default forgetPassword

//Forget password resend code
export const ForgetPasswordResendCode = (state = initialState, action) => {
  switch (action.type) {
    case FORGET_PASSWORD_RESEND_CODE:
      state = {
        ...state,
        forgetSuccessMsg: null,
        forgetError: null,
        forgetLoader: true,
      }
      break
    case FORGET_PASSWORD_RESEND_CODE_SUCCESS:
      state = {
        ...state,
        forgetSuccessMsg: action.payload,
        forgetLoader: false,
      }
      break
    case FORGET_PASSWORD_RESEND_CODE_ERROR:
      state = { ...state, forgetError: action.payload,forgetLoader: false, }
      break
    default:
      state = { ...state }
      break
  }
  return state
}